import { useState } from 'react'
import Box from '@mui/joy/Box'
import Snackbar from '@mui/joy/Snackbar'
import Button from '@mui/joy/Button'
import { Loading } from '../components/ui/Loading'
import { Error } from '../components/ui/Error'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { CampaignAPI } from '../api/CampaignAPI'
import { CreateNewCampaignButton } from '../components/CreateNewCampaignButton'
import { CampaignsTable } from '../components/CampaignsTable'
import { ConfirmModal } from '../components/ui/ConfirmModal'
import { EmptyState } from '../components/ui/EmptyState'
import { useNavigate } from 'react-router-dom'

export const Campaigns = () => {
    const navigate = useNavigate()
    const queryClient = useQueryClient()

    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isSnackOpen, setIsSnackOpen] = useState(false)
    const [snackMsg, setSnackMsg] = useState(null)
    const [targetCampaign, setTargetCampaign] = useState(null)
    const { isPending, isError, data } = useQuery({
        queryKey: ['campaigns'],
        queryFn: CampaignAPI.getAll,
    })

    const mutation = useMutation({
        mutationFn: (id) => {
            return CampaignAPI.delete(id)
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ['campaigns'] })
            setIsSnackOpen(true)
            setSnackMsg('Successfully deleted campaign')
        },
        onError: (data, variables, context) => {
            setIsSnackOpen(true)
            setSnackMsg('Error occurred deleted campaign')
        },
    })

    const confirmDelete = (campaign) => {
        setTargetCampaign(campaign)
        setIsModalOpen(true)
    }

    const deleteCampaign = () => {
        console.log('deleting campaign', targetCampaign)
        setIsModalOpen(false)
        mutation.mutate(targetCampaign.id)
    }

    const navToDetails = (campaign) => {
        navigate(`/merchant/view_campaign_v2/${campaign.id}`)
    }

    const handleNavigateToCampaingBuilder = () => {
        navigate('/merchant/campaign_builder')
    }

    if (isPending) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Loading message={`fetching campaigns...`} />
            </Box>
        )
    }

    if (isError) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Error />
            </Box>
        )
    }

    if (!isPending && data.data.length === 0) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginX: '1.5rem',
                }}
            >
                <EmptyState msg={`You have no campaigns created yet... 🙁`} />
                <CreateNewCampaignButton />
            </Box>
        )
    }

    return (
        <Box sx={{ m: 4 }}>
            <CampaignsTable
                campaigns={data.data}
                onItemClick={navToDetails}
                onItemDelete={confirmDelete}
            />
            <ConfirmModal
                title={`Delete ${targetCampaign?.title}`}
                message={`Are you sure you want to delete ${targetCampaign?.title}?`}
                confirmLabel="Delete"
                cancelLabel="Cancel"
                isOpen={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                onConfirm={deleteCampaign}
            />
            <Snackbar
                variant="solid"
                color="danger"
                autoHideDuration={3000}
                onClose={() => setIsSnackOpen(false)}
                open={isSnackOpen}
            >
                {snackMsg}
            </Snackbar>
        </Box>
    )
}
